/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchLoanOfficer } from './actions';

interface LoanOfficerState {
  loanOfficer: LoanOfficer | null;
  loading: boolean;
  error: any;
  currentRequestId?: string;
}

const initialState = {
  loanOfficer: null,
  loading: false,
  error: null,
  currentRequestId: undefined,
} as LoanOfficerState;

const loanOfficerSlice = createSlice({
  name: 'loanofficer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Without this guard a slower earlier response lands last and wins.
    builder.addCase(fetchLoanOfficer.pending, (state, { meta }) => {
      state.loading = true;
      state.currentRequestId = meta.requestId;
    });
    builder.addCase(fetchLoanOfficer.fulfilled, (state, { payload, meta }) => {
      if (state.currentRequestId !== meta.requestId) {
        return;
      }
      state.loanOfficer = payload;
      state.error = false;
      state.loading = false;
    });
    builder.addCase(fetchLoanOfficer.rejected, (state, { payload, meta }) => {
      if (state.currentRequestId !== meta.requestId) {
        return;
      }
      state.error = payload;
      state.loading = false;
    });
  },
});

export default loanOfficerSlice.reducer;
